import { ProductGame } from "@/@types/common";
import React from "react";
import { ThemeName } from "@/style/themes";

export const getIconForProduct = (product?: ProductGame) => {
  switch (product) {
    case ProductGame.Valorant:
      return VCIcon;
    case ProductGame.LegendsOfRuneterra:
      return LORCIcon;
    case ProductGame.WildRift:
      return WCIcon;
    case ProductGame.LeagueOfLegends:
    default:
      return RPIcon;
  }
};

export const getIconForTheme = (theme: ThemeName) => {
  switch (theme) {
    case "valorant":
      return VCIcon;
    case "lol":
      return RPIcon;
    case "wildrift":
      return WCIcon;
    case "lor":
      return LORCIcon;
    case "lion":
      return KOIcon;
    case "tft":
      return TFTIcon;
    default:
      return RPIcon;
  }
};

export type CurrencyIconProps = { size?: number; fill?: string };

export const VCIcon = ({ size = 32, fill = "#FCFCFC" }: CurrencyIconProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 28 28" fill="none">
    <circle opacity="0.5" cx="14" cy="14" r="13.5" stroke={fill} />
    <path
      d="M20.6654 8.74281V13.7924C20.6654 13.8729 20.6371 13.9508 20.5854 14.0136L19.293 15.587C19.224 15.6711 19.1193 15.72 19.0089 15.72H14.9165C14.8454 15.72 14.8058 15.6397 14.8502 15.5855L20.5142 8.69127C20.5641 8.62996 20.6654 8.66462 20.6654 8.74281Z"
      fill={fill}
    />
    <path
      d="M11.6669 19.1936L7.41172 14.0137C7.36001 13.9509 7.33203 13.873 7.33203 13.7924V8.74289C7.33203 8.6647 7.43332 8.63004 7.4832 8.69106L16.1097 19.1921C16.1541 19.2463 16.1145 19.3266 16.0434 19.3266H11.9509C11.8402 19.3266 11.7359 19.2777 11.6669 19.1936Z"
      fill={fill}
    />
  </svg>
);

export const RPIcon = ({ fill = "url(#gradient)", size = 32 }: CurrencyIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
    preserveAspectRatio="xMaxYMax meet"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.8464 4.0164L15.6348 0L10.4232 4.0164V18.546L15.6348 22.1369L20.8464 18.546V4.0164ZM29.1849 13.3569L31.2696 11.852L25.0157 6.09206V20.6217L17.7194 25.8108V31L31.2696 22.002L29.1849 19.5839V13.3569ZM6.25391 6.09206L0 11.852L2.08464 13.3569V19.5839L0 22.002L13.5501 31V25.8108L6.25391 20.6217V6.09206Z"
      fill={fill}
    />
    <defs>
      <linearGradient id="gradient" x1="15.6348" y1="0" x2="15.6348" y2="32" gradientUnits="userSpaceOnUse">
        <stop stopColor="#FEC845" />
        <stop offset="1" stopColor="#FEF2A7" />
      </linearGradient>
    </defs>
  </svg>
);

export const WCIcon = ({ fill = "url(#gradient)", size = 32 }: CurrencyIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 28 28"
    fill="none"
    preserveAspectRatio="xMaxYMax meet"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24.2076 4.2581C20.1267 0.428138 14.1094 0.823227 9.49817 4.41588C4.88692 8.00853 3.3562 13.5005 6.14992 18.327C4.22273 15.9018 3.23512 13.2359 3.59065 10.1823C3.94618 7.12871 5.51108 4.34962 7.94107 2.4564C10.3711 0.563179 13.4671 -0.289092 16.5481 0.087077C19.6291 0.463246 22.2804 1.8329 24.2076 4.2581ZM19.4592 28C24.6502 25.965 26.6158 20.3871 25.2397 14.7004C23.8637 9.01378 19.5533 5.09419 13.9835 5.543C15.4765 5.198 16.6125 5.07072 18.1294 5.31983C19.6463 5.56894 21.1012 6.11165 22.411 6.91694C23.7208 7.72224 24.8598 8.77435 25.7631 10.0132C26.6664 11.2521 27.3163 12.6535 27.6755 14.1373C28.0348 15.6212 28.0964 17.1585 27.8569 18.6614C27.6175 20.1643 27.0816 21.6035 26.2799 22.8967C25.4781 24.1898 24.4262 25.3118 23.1843 26.1984C21.9424 27.0849 20.9523 27.655 19.4592 28ZM0.602771 11.3463C-0.462767 16.7874 3.1222 21.6626 8.67414 23.6421C14.2261 25.6216 19.8216 23.8901 22.4311 19.0038C21.9285 20.4457 21.4658 21.7672 20.442 22.9027C19.4182 24.0382 18.1767 24.96 16.7888 25.615C15.4009 26.27 13.894 26.6453 12.3549 26.7194C10.8157 26.7934 9.27464 26.5647 7.82032 26.0464C6.36601 25.5281 5.02713 24.7304 3.88074 23.6992C2.73435 22.6681 1.80307 21.4238 1.14045 20.038C0.477829 18.6522 0.0969439 17.1522 0.0197352 15.6243C-0.0574736 14.0965 0.0827252 12.782 0.602771 11.3463Z"
      fill={fill}
    />
    <path d="M17.74 14.3836L14.205 9.13328L10.67 14.3836L14.205 20.5091L17.74 14.3836Z" fill={fill} />
    <defs>
      <linearGradient id="gradient" x1="15.6348" y1="0" x2="15.6348" y2="32" gradientUnits="userSpaceOnUse">
        <stop stopColor="#FEC845" />
        <stop offset="1" stopColor="#FEF2A7" />
      </linearGradient>
    </defs>
  </svg>
);

export const LORCIcon = ({ size = 32, fill = "#FCFCFC" }: CurrencyIconProps) => (
  <svg width={size} height={size} viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M32.1777 32.1785L22.2529 30.5403L22.032 29.3064L22.0376 29.3056L32.1777 28.0726V32.1785Z" fill={fill} />
    <path
      d="M32.1777 12.8906V26.4613L27.8509 26.9873L26.1245 17.2953L25.2918 17.6615L26.134 27.1962L21.7564 27.7293L20.1777 18.866L19.3546 19.2283L20.1237 27.9272L15.7961 28.4531L14.3604 20.397L13.5294 20.7632L14.2254 28.6446L11.6933 28.9521L8.366 16.4182L21.719 10.2974L32.1777 12.8906Z"
      fill={fill}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.5593 0C33.4662 0 43.1186 9.65323 43.1186 21.5601C43.1184 33.4668 33.4661 43.1194 21.5593 43.1194C9.65257 43.1194 0.000214698 33.4668 0 21.5601C0 9.65323 9.65244 0 21.5593 0ZM21.5593 2.57495C11.0742 2.57495 2.57415 11.0749 2.57415 21.5601C2.57437 32.0451 11.0743 40.5445 21.5593 40.5445C32.0444 40.5445 40.5443 32.0451 40.5445 21.5601C40.5445 11.0749 32.0445 2.57495 21.5593 2.57495Z"
      fill={fill}
    />
  </svg>
);

export const TFTIcon = ({ size = 32, fill = "#FCFCFC" }: CurrencyIconProps) => (
  <svg width={size} height={size} viewBox="0 0 40 46" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0 11.5V34.5L20 46L40 34.5V11.5L20 0L0 11.5ZM38.0345 12.6297V33.3693L20 43.7386L1.96545 33.3693V12.6297L20 2.26043L38.0345 12.6297Z"
      fill={fill}
      fillOpacity="0.5"
    />
    <path
      d="M13.4004 12.46L10.7148 16.4756L13.4004 25.1855L17.4668 26.8389V35.8076L19.8799 38.2432L22.292 35.8076V26.8408L26.3633 25.1855L29.0488 16.4756L26.3633 12.46L19.8818 10.8242L13.4004 12.46ZM24.4688 15.335V22.668H22.6357V15.335H24.4688ZM20.7998 15.335V22.668H18.9658V15.335H20.7998ZM17.1387 15.335V22.668H15.3047V15.335H17.1387Z"
      fill={fill}
    />
  </svg>
);

export const KOIcon = ({ fill = "#FCFCFC", size = 32 }: CurrencyIconProps) => (
  <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15.611 10.9588C14.6608 13.2902 12.6041 15.1489 9.91555 15.7782C7.22702 16.4073 4.52899 15.6617 2.59658 14.005L5.1048 13.4178C6.39872 14.0793 7.93343 14.3041 9.46416 13.9459C10.995 13.5877 12.2579 12.708 13.1028 11.5459L15.611 10.9588ZM7.66541 7.78331L5.82368 8.21445L5.82408 8.80582L7.66581 8.37467L7.66823 11.8916L4.1273 12.7204L4.12608 10.8881L3.54472 11.024L3.54607 12.8564L0.00538793 13.685L0 6.06111L3.54095 5.23233L3.54217 7.06483L4.12338 6.92884L4.1223 5.09634L7.66298 4.26769L7.66541 7.78331ZM16 9.93929L8.33702 11.7327L8.33177 4.10879L15.9946 2.31535L16 9.93929ZM11.8742 5.44936L11.8763 8.73551L12.4577 8.59951L12.4555 5.31323L11.8742 5.44936ZM6.08446 0.221869C8.77308 -0.407387 11.4711 0.338484 13.4036 1.99531L10.8945 2.58256C9.60076 1.92146 8.06628 1.69683 6.53583 2.05502C5.00532 2.41325 3.74277 3.29266 2.8979 4.45439L0.388874 5.04165C1.33905 2.71002 3.39571 0.851153 6.08446 0.221869Z"
      fill={fill}
    />
  </svg>
);
